import React from 'react';
import { HStack, Text, Icon, Tag, // For 'Signature Required'
TagLabel, } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next'; // Import useTranslation
import { FiFileText } from 'react-icons/fi'; // Example icons
import COLORS from '../../../../../constants/colors';
// Simple function to get a color based on document type name
// TODO: Expand this mapping with actual types and desired colors
const getTypeColor = (typeName) => {
    switch (typeName) {
        case 'Meeting Minutes':
            return COLORS.Govrn.Blue.T500.value;
        case 'Financial Report':
            return COLORS.Govrn.PastelGreen.T500.value; // Use PastelGreen
        case 'Strategic Plan':
            return COLORS.Govrn.Purple.T500.value;
        case 'SignatureRequest':
            return COLORS.Govrn.Yellow.T500.value; // Use Yellow
        default:
            return COLORS.Text.T300.value; // Default gray
    }
};
const EventDocumentItem = ({ document, onDocumentPress, }) => {
    const { t } = useTranslation(); // Get translation hook
    const documentTitleStyle = { fontSize: '14px', fontWeight: 'normal' };
    const typeColor = getTypeColor(document.typeName);
    // Translate typeName, fallback to original key if not found
    const translatedTypeName = document.typeName
        ? t(document.typeName, { defaultValue: document.typeName })
        : 'Unknown Type';
    return (<HStack as="button" width="100%" onClick={() => onDocumentPress(document)} py={1.5} px={2} _hover={{ bg: 'gray.50' }} borderRadius="md" spacing={3} // Increased spacing slightly after removing dot
     alignItems="center">
      <Icon as={FiFileText} boxSize={4} color={COLORS.Text.T400.value}/>

      <Text {...documentTitleStyle} noOfLines={1} flexShrink={1} textAlign="left" mr={2}>
        {document.title || 'Untitled Document'}
      </Text>

      {document.typeName && (<Tag size="sm" variant="subtle" flexShrink={0} bg={`${typeColor}20`} color={typeColor} borderRadius="full">
          <TagLabel>{translatedTypeName}</TagLabel>
        </Tag>)}
    </HStack>);
};
export default EventDocumentItem;
